<template>
    <v-container class="fill-height inicio" fluid>
        <v-row align="center" justify="center">
            <v-col cols="12" sm="8" md="6">
                <v-layout wrap>
                    <v-flex mb-8 xs12>
                        <v-layout justify-center>
                            <h1 class="display-2 font-weight-bold mb-8 white--text">
                                Bienvenido al Almacén de Carexlogistics
                            </h1>
                        </v-layout>
                        <p class="subheading font-weight-regular white--text">
                            Si su empresa necesita preparar pedidos para sus clientes, cuente con nuestros almacenes y nuestro servicio de <b>Picking y Packing</b>.
                        </p>
                    </v-flex>
                </v-layout>
            </v-col>
        </v-row>
        <v-col cols="2"></v-col>
    </v-container>
</template>

<script>
    export default {
        name: 'Inicio'
    };
</script>

<style>
    main div.v-main__wrap > div.inicio {
        background: url('../assets/almacen.jpg')
    }
</style>